export const stageLabels = { not_started: 'Nothing was sent', processing: 'Sending…', completed: 'Completed', submitted: 'Sent — accepted by WhatsApp, not delivered', failed: 'Failed', rejected: 'Rejected', not_sent: 'Not sent', reconciliation_required: 'Being checked' };

export function stopReason(resource) {
  if (!resource?.stop_code) return '';
  const reason = ({ SequelizeConnectionAcquireTimeoutError: 'server busy', ER_LOCK_DEADLOCK: 'server busy',
    ER_LOCK_WAIT_TIMEOUT: 'server busy', MESSAGING_OUTREACH_LEASE_LOST: 'interrupted' })[resource.stop_code]
    || `Unexpected problem (${resource.stop_code})`;
  const step = ['prepare_dispatch', 'ready'].includes(resource.stop_step) ? 'while preparing' : 'while sending';
  return `Stopped ${step} (${reason}).${resource.status === 'not_started' ? ' Nothing was sent.' : ''}`;
}
